import axios from "axios";

// const baseUrl = "https://dev-api.limberhealth.com/v2";

// const baseUrl = "http://127.0.0.1:3000";

const baseUrl = "https://mlcajf5031.execute-api.us-east-1.amazonaws.com/develop/"

export const getQuestion = (questionId) => {
  let url = `${baseUrl}/questions/${questionId}`;
  return axios.get(url).then((res) => {
    return res.data;
  });
};

export const updateQuestion = (question) => {
  let url = `${baseUrl}/questions/${question.id}`;
  return axios.put(url, question).then((res) => {
    return res.data;
  });
};

export const createQuestion = (question) => {
  let url = `${baseUrl}/questions`;
  return axios.post(url, question).then((res) => {
    return res.data;
  });
};

export const getAnswer = (answerId) => {
  let url = `${baseUrl}/answers/${answerId}`;
  return axios.get(url).then((res) => {
    return res.data;
  });
};

export const updateAnswer = (answer) => {
  let url = `${baseUrl}/answers/${answer.id}`;
  return axios.put(url, answer).then((res) => {
    return res.data;
  });
};

export const createAnswer = (answer) => {
  let url = `${baseUrl}/answers`;
  return axios.post(url, answer).then((res) => {
    return res.data;
  });
};

export const getAssessment = (assessmentId) => {
  let url = `${baseUrl}/assessments/${assessmentId}`;
  return axios.get(url).then((res) => {
    return res.data;
  });
};

export const getOrganization = (organizationId) => {
  let url = `${baseUrl}/organizations/${organizationId}`;
  return axios.get(url).then((res) => {
    return res.data;
  });
};

export const getOrganizations = () => {
  let url = `${baseUrl}/organizations`;
  return axios.get(url).then((res) => {
    return res.data;
  });
};

export const updateAssessment = (assessment) => {
  let url = `${baseUrl}/assessments/${assessment.id}`;
  return axios.put(url, assessment).then((res) => {
    return res.data;
  });
};

export const createAssessment = (assessment) => {
  let url = `${baseUrl}/assessments`;
  return axios.post(url, assessment).then((res) => {
    return res.data;
  });
};

export const getAssessmentSection = (id) => {
  let url = `${baseUrl}/assessmentSections/${id}`;
  console.log(url);
  return axios.get(url).then((res) => {
    return res.data;
  });
};

export const updateAssessmentSection = (assessmentSection) => {
  let url = `${baseUrl}/assessmentSections/${assessmentSection.id}`;
  return axios.put(url, assessmentSection).then((res) => {
    return res.data;
  });
};

export const createAssessmentSection = (assessmentSection) => {
  let url = `${baseUrl}/assessmentSections`;
  return axios.post(url, assessmentSection).then((res) => {
    return res.data;
  });
};

export const deleteQuestion = (questionId) => {
  let url = `${baseUrl}/questions/${questionId}`;
  return axios.delete(url).then((res) => {
    return res.data;
  });
};

export const deleteAssessmentSection = (questionId) => {
  let url = `${baseUrl}/assessmentSections/${questionId}`;
  return axios.delete(url).then((res) => {
    return res.data;
  });
};

export const deleteAnswer = (questionId) => {
  let url = `${baseUrl}/answers/${questionId}`;
  return axios.delete(url).then((res) => {
    return res.data;
  });
};

export const getReports = () => {
  let url = `${baseUrl}/reportCategories`;
  return axios.get(url).then((res) => {
    return res.data;
  });
}